<template>
  <select class="dropdown-component-container" @input="onInputChange">
    <option
      class="dropdown-option"
      :value="option.value"
      :key="option.key || option.value"
      v-for="option in options"
      :selected="selectedValue === option.value"
    >
      {{ option.description }}
    </option>
  </select>
</template>

<script>
export default {
  name: 'DropdownComponent',
  props: {
    options: {
      type: Array,
      required: true,
    },
    selectedValue: [String, Number],
  },
  methods: {
    onInputChange($event) {
      this.$emit('input', $event.target.value)
    },
  },
}
</script>

<style lang="scss" scoped></style>
